import React from "react";
import LandingPic1 from "../Assests/Image2.jpeg";
import LandingPic2 from "../Assests/Image4.jpeg";
import LandingPic3 from "../Assests/Image3.jpeg";
import LandingPic4 from "../Assests/Image6.jpeg";
import LandingPic5 from "../Assests/Image7.jpeg";
import LandingPic6 from "../Assests/Image5.jpeg";
import LandingPic7 from "../Assests/Image8.jpeg";

const WhyChooseUs = () => {
  return (
    <div className="relative bg-[#F6F6F6] overflow-hidden">
      <div className="pb-80 pt-16 sm:pb-40 sm:pt-24 lg:pb-48 lg:pt-40">
        <div className="relative mx-auto max-w-7xl px-4 sm:static sm:px-6 lg:px-8">
          <div className="sm:max-w-lg">
            <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
              Why Choose Us
            </h1>
            <p className="mt-4 text-xl text-gray-500">
              Reliable Homecare,where compassionate care meets a commitment to
              enhancing daily life. With a comprehensive array of services, we
              go beyond typical home care to provide daily living assistance,
              personal care, and light housekeeping tailored to your unique
              needs. From meal preparation to companionship, our dedicated team
              excels in ensuring your comfort and well-being. We offer a full
              spectrum of support, including assistance with gro Reliable
              Homecare, we're not just caregivers – we're companions, assisting
              with everything from planning daily schedules to celebrating
              birthdays, creating a warm and personalized experience for you or
              your loved ones.
            </p>
          </div>
          <div>
            <div className="mt-10">
              <div
                aria-hidden="true"
                className="pointer-events-none lg:absolute lg:inset-y-0 lg:mx-auto lg:w-full lg:max-w-7xl"
              >
                <div className="absolute transform sm:left-1/2 sm:top-0 sm:translate-x-8 lg:left-1/2 lg:top-1/2 lg:-translate-y-1/2 lg:translate-x-8">
                  <div className="flex items-center space-x-6 lg:space-x-8">
                    <div className="grid flex-shrink-0 grid-cols-1 gap-y-6 lg:gap-y-8">
                      <div className="h-64 w-44 overflow-hidden rounded-lg sm:opacity-0 lg:opacity-100">
                        <img
                          src={LandingPic1}
                          alt=""
                          className="h-full w-full object-cover object-center"
                        />
                      </div>
                      <div className="h-64 w-44 overflow-hidden rounded-lg">
                        <img
                          src={LandingPic2}
                          alt=""
                          className="h-full w-full object-cover object-center"
                        />
                      </div>
                    </div>
                    <div className="grid flex-shrink-0 grid-cols-1 gap-y-6 lg:gap-y-8">
                      <div className="h-64 w-44 overflow-hidden rounded-lg">
                        <img
                          src={LandingPic3}
                          alt=""
                          className="h-full w-full object-cover object-center"
                        />
                      </div>
                      <div className="h-64 w-44 overflow-hidden rounded-lg">
                        <img
                          src={LandingPic4}
                          alt=""
                          className="h-full w-full object-cover object-center"
                        />
                      </div>
                      <div className="h-64 w-44 overflow-hidden rounded-lg">
                        <img
                          src={LandingPic5}
                          alt=""
                          className="h-full w-full object-cover object-center"
                        />
                      </div>
                    </div>
                    <div className="grid flex-shrink-0 grid-cols-1 gap-y-6 lg:gap-y-8">
                      <div className="h-64 w-44 overflow-hidden rounded-lg">
                        <img
                          src={LandingPic6}
                          alt=""
                          className="h-full w-full object-cover object-center"
                        />
                      </div>
                      <div className="h-64 w-44 overflow-hidden rounded-lg">
                        <img
                          src={LandingPic7}
                          alt=""
                          className="h-full w-full object-cover object-center"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default WhyChooseUs;
